export const GET_NETWORK_DATA = 'GET_NETWORK_DATA';
export const GET_FRIENDS = 'GET_FRIENDS';
export const GET_FRIENDS_REQUESTS = 'GET_FRIENDS_REQUESTS';
export const GET_FOLLOWS = 'GET_FOLLOWS';
export const FRIEND_APPROVE = 'FRIEND_APPROVE';
export const FRIEND_DECLINE = 'FRIEND_DECLINE';
export const GET_SUGGESTED_PEOPLE = 'GET_SUGGESTED_PEOPLE';
export const FOLLOW_USER = 'FOLLOW_USER_NETWORK_PAGE';
export const UNFOLLOW_USER = 'UNFOLLOW_USER_NETWORK_PAGE';
